import { Component, OnInit, OnDestroy, ViewEncapsulation, ComponentFactoryResolver, ChangeDetectorRef } from '@angular/core';
import { ApiService } from '@services/api/api.service';
import { IdentityAuthService } from '@services/identity-auth/identity-auth.service';
import { Router, ActivatedRoute } from '@angular/router';
import { FormController } from '../../controllers/FormController';
import { NestedNavigationService } from '../../../services/nested-navigation/nested-navigation.service';
import { ToastrService } from 'ngx-toastr';
import { BreadCrumbsService } from '../../../services/bread-crumbs/bread-crumbs.service';
import { IEntityOptions } from '../../interfaces/IEntity';
import { ToolbarActionsService } from '../../../services/toolbar-actions/toolbar-actions.service';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MfPopupPanelComponent } from '../mf-popup-panel/mf-popup-panel.component';
import { ConfirmationService } from 'primeng/api';

export interface IDetailComponent {
  displayName: string;
  component?: any;
  isHidden?: boolean;
  index?: number;
  isMenuHidden?: boolean | Function;
  click?: Function;
  bladeIndexToNavigateTo?: number;
  menuHidden?: boolean;
  getDataEvenIfIsMenuHidden?: boolean;
  icon?: string;
  entityOptions?: IEntityOptions;
  loadOnlyOnEntityId?:boolean
}

export interface IButtonAction {
  text?: string;
  iconClass?: string;
  click?: Function;
  tooltip?: string;
}

@Component({
  selector: 'app-mf-panel',
  templateUrl: './mf-panel.component.html',
  styles: [':host {display: block !important;}'],
  //styleUrls: ['@framework/components/mf-blade/mf-blade.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class MfPanelComponent extends FormController implements OnInit, OnDestroy {
  constructor(apiService?: ApiService,
    route?: ActivatedRoute,
    componentFactoryResolver?: ComponentFactoryResolver,
    messageService?: ToastrService,
    confirmationService?: ConfirmationService,
    dialogService?: MatDialog,
    auth?: IdentityAuthService,
    nestedNavigationService?: NestedNavigationService,
    breadCrumbService?: BreadCrumbsService,
    toolbarActionService?: ToolbarActionsService,
    cdr?: ChangeDetectorRef) {
    super(apiService, route, componentFactoryResolver, messageService, confirmationService, dialogService, auth, nestedNavigationService, breadCrumbService, cdr,toolbarActionService);
  }
}
